import {
  createContext,
  Dispatch,
  SetStateAction,
  useContext,
  useState,
} from 'react';
import { AdminToolsView } from '../../admin/admin-inbox-table/admin-inbox-table';

type AdminContextProps = {
  selectedInboxItem: string | undefined;
  setSelectedInboxItem: Dispatch<SetStateAction<string | undefined>>;
  adminView: AdminToolsView;
  fetchTableRecordsErrorMessage: string;
  defaultInboxTableText: string;
  tableEmptyText: string;
  inboxEmptyText: string;
  exportTooltipMessage?: string;
};

export const AdminContext = createContext<AdminContextProps>(
  {} as AdminContextProps
);

export type AdminProviderProps = {
  children: React.ReactNode;
  adminView: AdminToolsView;
  fetchTableRecordsErrorMessage: string;
  defaultInboxTableText: string;
  tableEmptyText: string;
  inboxEmptyText: string;
  exportTooltipMessage?: string;
};

export const AdminProvider = ({ children, ...props }: AdminProviderProps) => {
  const [selectedInboxItem, setSelectedInboxItem] = useState<string>();
  return (
    <AdminContext.Provider
      value={{
        selectedInboxItem,
        setSelectedInboxItem,
        ...props,
      }}
    >
      {children}
    </AdminContext.Provider>
  );
};

export const useAdminContext = () => {
  const context = useContext(AdminContext);
  if (!context) {
    throw new Error('useAdminContext must be used within an AdminProvider');
  }
  return context;
};
